<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<div style="text-align: center;">
<div style="min-width: 200px; max-width: 600px; padding: 20px; margin-left: auto; margin-right: auto;">


    <h3>{{"FXRATE.TITLE" | translate}}</h3>

    <ng-container *ngIf="!rate">

    <form [formGroup]="form" *ngIf="form">

      <div>
        <mat-form-field class="full-width">
          <mat-select [placeholder]="'FXRATE.SOURCE_CURRENCY' | translate" formControlName="sourceCurrency" disabled>
            <mat-option [value]="'EUR'">EUR - Euro</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div #currencyContainer>
        <mat-form-field class="full-width" >
          <mat-select [placeholder]="'FXRATE.TARGET_CURRENCY' | translate" formControlName="targetCurrency" required>
            <mat-option *ngFor="let currency of currencies" [value]="currency.alphaCd">
              {{ displayFullName ? currency.currName : currency.alphaCd }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field class="full-width">
          <mat-select [placeholder]="'FXRATE.CARD_TYPE' | translate" formControlName="cardType" required>
            <mat-option [value]="'kingplus'">king+</mat-option>
            <mat-option [value]="'king'">king</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <button [disabled]="isLoading" mat-raised-button color="kingorange" (click)="getRate()" style="margin-right: 20px;">{{"FXRATE.CALCULATE" | translate}}</button>

    </form>
    </ng-container>

      <ng-container *ngIf="rate">
        <div class="cur_head">{{"FXRATE.CURRENCY_OF_YOUR_CARD" | translate}}</div>
        <div class="cur_val">{{rate.source}}</div>
        <div class="cur_head">{{"FXRATE.CARD_TYPE" | translate}}</div>
        <div class="cur_val">
          <ng-container *ngIf="cardType === 'kingplus'">
            king+
          </ng-container>
          <ng-container *ngIf="cardType === 'king'">
            king
          </ng-container>

        </div>
        <div class="cur_head">{{"FXRATE.TARGET_CURRENCY" | translate}}</div>
        <div class="cur_val">{{rate.target}}</div>
        <div class="cur_head">{{"FXRATE.RATE_OF_THE_ECB" | translate}}</div>
        <div class="cur_val">1 EUR ≅ {{1/rate.ecbReferenceRate}} {{currency.alphaCd}}</div>
        <div class="cur_head">{{"FXRATE.RATE_MASTERCARD" | translate}}</div>
        <div class="cur_val">1 EUR ≅ {{1/rate.mcRate}} {{currency.alphaCd}}</div>
        <div class="cur_head">{{"FXRATE.EFFECTIVE_RATE" | translate}}</div>
        <div class="cur_val">1 EUR ≅ {{1/rate.effectiveRate}} {{currency.alphaCd}}</div>
        <div class="cur_head">{{"FXRATE.MARKUP_ON_ECB_RATE" | translate}}</div>
        <div class="cur_val">{{ (((rate.effectiveRate / rate.ecbReferenceRate) * 100 - 100 ) | number: '1.4-4') + '%' }}</div>
        <div class="cur_head">{{"FXRATE.MARKUP_ON_MASTERCARD_RATE" | translate}}</div>
        <div class="cur_val">{{ (((rate.effectiveRate / rate.mcRate) * 100 - 100 ) | number: '1.4-4') + '%' }}</div>

        <button mat-raised-button (click)="clearRate()" style="margin-right: 20px;">{{"FXRATE.START_OVER" | translate}}</button>

      </ng-container>


</div>
</div>
